module.exports = __webpack_public_path__ + "static/media/xlsx-simple-icon.aa77642b.svg";